/*----------------------------------
- AGENDA: EVENT DETAIL TRANSPORT
----------------------------------*/

/**
 * @docs docs/features/agenda
 * @adr  ADR-0073
 * @rule One request per event a visitor opens, posted to the Website gateway, which answers from
 *       its keyed cache before Product sees it. The board keeps the answers for the page's life.
 */

import type { AgendaEventDetail } from '@uniquedomains/components/contracts/agenda/eventDetail';

import { AGENDA_EVENT_GATEWAY_PATH, type AgendaEventGatewayRequest } from '@/common/contracts/agendaGateway';
import type { PublicReadResult } from '@/common/contracts/publicReadResult';

/** @boundary The gateway's JSON answer, the shape `server/routes/agenda.ts` writes. */
const readGatewayAnswer = async (response: Response): Promise<PublicReadResult<AgendaEventDetail | null>> =>
    (await response.json()) as PublicReadResult<AgendaEventDetail | null>;

/** Rejects when the gateway is unreachable or answers `unavailable`: the modal then says so. */
export const fetchAgendaEventDetail = async (id: string): Promise<AgendaEventDetail | null> => {
    const body: AgendaEventGatewayRequest = { id };
    const response = await window.fetch(AGENDA_EVENT_GATEWAY_PATH, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    const result = response.ok ? await readGatewayAnswer(response) : null;
    if (!result || result.status !== 'success') throw new Error('The agenda event details are unavailable.');
    return result.value;
};
